import ListCreditScoreDoughnutChartBox from './ListCreditScoreDoughnutChartBox'

export default ListCreditScoreDoughnutChartBox
